var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCycleCount(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 3C9.48 3 5 7.48 5 13C5 15.38 6 17.5 7.68 19.02L6.5 20.2C6.21 20.49 6 20.98 6 21.5C6 22.33 6.67 23 7.5 23C8.02 23 8.51 22.79 8.8 22.5L11.5 19.8C11.89 19.41 12 18.87 12 18.33V16.5C12 15.67 11.33 15 10.5 15C9.67 15 9 15.67 9 16.5V17.08C7.83 16.05 7 14.6 7 13C7 8.58 10.58 5 15 5C19.42 5 23 8.58 23 13C23 17.42 19.42 21 15 21C13.6 21 12.26 20.58 11.14 19.85C10.49 19.44 9.61 19.66 9.2 20.31C8.79 20.96 9.01 21.84 9.66 22.25C11.03 23.15 12.72 23.67 14.5 23.67C20.02 23.67 24.5 19.19 24.5 13.67C24.5 8.15 20.02 3.67 15 3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCycleCount);
export default __webpack_public_path__ + "static/media/cycle-count.c47778016d5690a225ab6843d77b904a.svg";
export { ForwardRef as ReactComponent };